import Base from './Base';

export default class DashboardStat extends Base {
  id: number;
  year: number;
  month: number;
  areaId: number;
  grossAmount: number;
  expenseAmount: number;
  netAmount: number;
  areaName: string;
  occupancy: number;

  constructor(data: any) {
    super();
    this.id = data.id;
    this.year = data.year;
    this.month = data.month;
    this.areaId = data.areaId;
    this.grossAmount = data.grossAmount;
    this.expenseAmount = data.expenseAmount;
    this.netAmount = data.netAmount;
    this.areaName = data.areaName;
    this.occupancy = data.occupancy;
  }

  static parseFromData(data: any): DashboardStat {
    return new DashboardStat({
      id: data.id,
      year: data.year,
      month: data.month,
      areaId: data.area_id,
      grossAmount: data.gross_amount,
      expenseAmount: data.expense_amount,
      netAmount: data.net_amount,
      areaName: data.areaName,
      occupancy: data.occupancy,
    });
  }
}
